import { useTrustpilotLoader } from 'hooks/useTrustpilotLoader';
import { useRef } from 'react';
import { formatLocaleWithUppercaseCountry } from 'util/formatLocaleWithUppercaseCountry';

interface TrustpilotWidgetProps {
  locale: Locale;
  onLoad: () => void;
  templateId: string;
  width: string;
  height: number;
  className?: string;
}

export const TrustpilotWidget = ({
  locale,
  onLoad,
  templateId,
  width,
  height,
  className = '',
}: TrustpilotWidgetProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const formattedLocale = formatLocaleWithUppercaseCountry(locale);

  useTrustpilotLoader({ onLoad, containerRef });

  return (
    <div
      ref={containerRef}
      data-locale={formattedLocale}
      data-template-id={templateId}
      data-style-height={`${height}px`}
      data-style-width={width}
      data-businessunit-id="5ea92557e44daa0001066e38"
      className={className}
    />
  );
};
